/* global FB */
import "./Login.css";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import logo from "../../assets/logofuntalk.png";
import axios from "axios";

function Login() {
  const { id: company } = useParams(); // Get the id from URL
  const id = "2624278807586857"; // appId
  const version = "v21.0"; // versão do SDK do Facebook

  useEffect(() => {
    // You can now use urlId parameter
    console.log("URL Parameter ID:", company);

    const handleMessage = (event) => {
      if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") return;
      try {
        const data = JSON.parse(event.data);
        axios.post('https://meta-es-backend.api.fintalk.io/grant', 
          {
            data,
          },
          {
            headers: {
              'x-api-key': 'nCFNGTiXWw4u5GeMDk3fZ9psydZB3gPi2mH65nMU'
            }
          }
        )
        .then(result => {
          console.log('Ev response:');
        })
        .catch(error => {
          console.error('Error making grant request:', error);
        });
      } catch {
        console.log('message event: ', event.data);
      }
    }

    window.addEventListener('message', handleMessage);
    // Carregar o SDK do Facebook
    const loadFacebookSDK = () => {
      (function (d, s, id) {
        let js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");

      window.fbAsyncInit = function () {
        // Inicializar o SDK com os parâmetros apropriados
        FB.init({
          appId: id,
          xfbml: true,
          version: version,
        });

        // Esperar o SDK estar completamente carregado e então criar o widget
        if (FB && FB.Widgets && FB.Widgets.WhatsappEmbeddedSignup) {
          FB.Widgets.WhatsappEmbeddedSignup.create({
            businessType: "MERCHANT",
            element: document.getElementById("whatsapp-signup"),
          });
        } else {
          console.error("O widget WhatsappEmbeddedSignup não está disponível.");
        }
      };
    };

    loadFacebookSDK();
  }, [id, version, company]);

  const handleFacebookLogin = () => {
    FB.login(
      (response) => {
        if (response.authResponse) {
          console.log(response);
          axios.post('https://meta-es-backend.api.fintalk.io/grant', 
            {
              code: response.authResponse.code,
              company: company,
              fullData: response,
            },
            {
              headers: {
                'x-api-key': 'nCFNGTiXWw4u5GeMDk3fZ9psydZB3gPi2mH65nMU'
              }
            }
          )
          .then(result => {
            console.log('Grant response:', result.data);
          })
          .catch(error => {
            console.error('Error making grant request:', error);
          });
        } else {
          console.log(
            "Usuário cancelou o login ou não autorizou completamente."
          );
        }
      },
      {
        config_id: "3953543934888581",
        response_type: "code",
        override_default_response_type: true,
        extras: {
          setup: {},
          featureType: "whatsapp_business_app_onboarding",
          sessionInfoVersion: "3",
        },
      }
    );
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <img src={logo} alt="Logo" className="logo" />
        {/* Botão de login do Facebook */}
        <button
          type="submit"
          onClick={handleFacebookLogin}
          className="sign-in-btn"
        >
          Sign In
        </button>
        {/* Container para o widget do WhatsApp */}
        <div id="whatsapp-signup"></div>
      </div>
    </div>
  );
}

export default Login;
